import { ModerationStatus, RulebookStatus, RulebookVisibility } from "@next-platform/packages-ts-types";
import { RulebookListCardStatus } from "./RulebookListCardStatus";
/** Open-report and moderation states win over visibility, with the same precedence as the web card badge. */
const resolveModerationStatus = (summary) => {
    const moderationStatus = summary.moderation_report_status ?? summary.moderation_status;
    if (moderationStatus === ModerationStatus.FixRequired) {
        return RulebookListCardStatus.NEEDS_CHANGES;
    }
    if (moderationStatus === ModerationStatus.Pending || moderationStatus === ModerationStatus.RereviewRequired) {
        return RulebookListCardStatus.IN_REVIEW;
    }
    if (summary.status === RulebookStatus.MODERATION_FAILED) {
        return RulebookListCardStatus.NEEDS_CHANGES;
    }
    if (summary.status === RulebookStatus.IN_MODERATION) {
        return RulebookListCardStatus.IN_REVIEW;
    }
    return undefined;
};
const resolveRulebookListCardStatus = ({ summary }) => {
    if (!summary || summary.status === RulebookStatus.DRAFT) {
        return RulebookListCardStatus.DRAFT;
    }
    const moderationStatus = resolveModerationStatus(summary);
    if (moderationStatus) {
        return moderationStatus;
    }
    return summary.visibility === RulebookVisibility.PUBLIC ? RulebookListCardStatus.PUBLIC : RulebookListCardStatus.PRIVATE;
};
export default resolveRulebookListCardStatus;
